import React from "react";
import FormElement from "../../components/FormBuilder/FormElement";
import { Grid, Box } from "@mui/material";
import SignatureFileFillElement from "./SignatureFileFillElement";
import RadioSelectionFillElement from "./RadioSelectionFillElement";
import CheckboxFillElement from "./CheckboxFillElement";

const HorizontalContainerFillElement = ({ element }) => {
  return (
    <Box display="flex" width="100%" style={{ minHeight: "50px" }}>
      <Grid container spacing={2}>
        {element.items.map((item) => (
          <Grid item key={item.id}>
            {item.type === "fileUpload" ? (
              <SignatureFileFillElement element={item} />
            ) : item.type === "radioSelection" ? (
              <RadioSelectionFillElement element={item} />
            ) : item.type === "checkBox" ? (
              <CheckboxFillElement element={item} />
            ) : (
              <FormElement element={item} dragHandle={false} />
            )}
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default HorizontalContainerFillElement;
